<div class="table-footer">
    <!-- Record count -->
    <div class="page-count"
         *ngIf="config.pager.groupToolCount">{{'table.totalRecords' | translate}} {{config.pager.groupToolCount}}</div>
    <div class="page-count" [ngClass]="config.pager.groupToolCount ? 'align-right' : 'align-left'"
         *ngIf="config.pager.count">{{'table.total' | translate}} {{config.pager.count}}</div>
    <!-- Selected items count -->
    <div class="page-selected"
         *ngIf="selectableRows">{{'table.totalSelected' | translate}} {{config.pager.selected}}</div>

    <!-- Pagination -->
    <div *ngIf="hasPagination"
         class="app-pager-wrapper">
        <app-pagination [pagination]="config"
                        (pageChange)="onPageChange()">
        </app-pagination>
    </div>
</div>


